const languages = {
  sp: {
    label: "Spanish",
  },
  gr: {
    label: "German",
  },
  rs: {
    label: "Russian",
  },
  it: {
    label: "Italian",
  },
  en: {
    label: "English",
  },
};

export default languages;
